import React, { useState } from 'react';
import { DepositFrequency, DepositDateData } from './AddGoalDepositFlow';
import { WEEK_DAYS_SHORT } from './constants';
import { Icon } from '../Icon';
import './DepositDateSelector.css';

interface DepositDateSelectorProps {
  frequency: DepositFrequency;
  dayOfWeek?: number;
  dayOfMonth?: number;
  dayAndMonth?: { day: number; month: number };
  onChange: (data: DepositDateData) => void;
  onBack: () => void;
}

const monthDays = Array.from({ length: 31 }, (_, i) => i + 1);

export const DepositDateSelector: React.FC<DepositDateSelectorProps> = ({
  frequency,
  dayOfWeek,
  dayOfMonth,
  dayAndMonth,
  onChange,
  onBack
}) => {
  const [selectedDayOfWeek, setSelectedDayOfWeek] = useState<number>(dayOfWeek ?? 0);
  const [selectedDayOfMonth, setSelectedDayOfMonth] = useState<number>(dayOfMonth ?? 1);
  const [selectedDayAndMonth, setSelectedDayAndMonth] = useState<{ day: number; month: number }>(
    dayAndMonth || { day: 1, month: 1 }
  );

  const renderWeeklySelector = () => {
    return (
      <div className="deposit-date-selector__weekly">
        <p className="deposit-date-selector__description">
          Выберите день недели для регулярного пополнения
        </p>
        <div className="deposit-date-selector__info-box">
          💡 Первое пополнение будет в дату, которую вы укажете на следующем шаге. 
          Затем каждую неделю в выбранный день.
        </div>
        <div className="weekday-grid">
          {WEEK_DAYS_SHORT.map((day, index) => (
            <button
              key={index}
              className={`weekday-btn ${selectedDayOfWeek === index ? 'weekday-btn--active' : ''}`}
              onClick={() => setSelectedDayOfWeek(index)}
            >
              {day}
            </button>
          ))}
        </div>
        <button
          className="deposit-date-selector__submit"
          onClick={() => onChange({ dayOfWeek: selectedDayOfWeek })}
        >
          Далее
        </button>
      </div>
    );
  };

  const renderMonthlySelector = () => {
    return (
      <div className="deposit-date-selector__monthly">
        <p className="deposit-date-selector__description">
          Выберите день месяца для регулярного пополнения
        </p>
        <div className="deposit-date-selector__info-box">
          💡 Первое пополнение будет в дату, которую вы укажете на следующем шаге. 
          Затем каждый месяц в выбранное число.
        </div>
        <div className="monthday-grid">
          {monthDays.map((day) => (
            <button
              key={day}
              className={`monthday-btn ${selectedDayOfMonth === day ? 'monthday-btn--active' : ''}`}
              onClick={() => setSelectedDayOfMonth(day)}
            >
              {day}
            </button>
          ))}
        </div>
        <button
          className="deposit-date-selector__submit"
          onClick={() => onChange({ dayOfMonth: selectedDayOfMonth })}
        >
          Далее
        </button>
      </div>
    );
  };

  const renderYearlySelector = () => {
    return (
      <div className="deposit-date-selector__yearly">
        <p className="deposit-date-selector__description">
          Выберите день и месяц для регулярного пополнения
        </p>
        <div className="deposit-date-selector__info-box">
          💡 Первое пополнение будет в дату, которую вы укажете на следующем шаге. 
          Затем каждый год в выбранную дату.
        </div>
        <div className="yearly-inputs">
          <div className="yearly-input-group">
            <label>День</label>
            <select
              className="yearly-select"
              value={selectedDayAndMonth.day}
              onChange={(e) => setSelectedDayAndMonth({ ...selectedDayAndMonth, day: parseInt(e.target.value) })}
            >
              {monthDays.map((day) => (
                <option key={day} value={day}>{day}</option>
              ))}
            </select>
          </div>
          <div className="yearly-input-group">
            <label>Месяц</label>
            <select
              className="yearly-select"
              value={selectedDayAndMonth.month}
              onChange={(e) => setSelectedDayAndMonth({ ...selectedDayAndMonth, month: parseInt(e.target.value) })}
            >
              {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                <option key={month} value={month}>
                  {new Date(2024, month - 1).toLocaleString('ru', { month: 'long' })}
                </option>
              ))}
            </select>
          </div>
        </div>
        <button
          className="deposit-date-selector__submit"
          onClick={() => onChange({ dayAndMonth: selectedDayAndMonth })}
        >
          Далее
        </button>
      </div>
    );
  };

  const renderContent = () => {
    switch (frequency) {
      case 'weekly':
        return renderWeeklySelector();
      case 'monthly':
        return renderMonthlySelector();
      case 'yearly':
        return renderYearlySelector();
      default:
        return null;
    }
  };

  return (
    <div className="deposit-date-selector step-content">
      <div className="deposit-date-selector__header">
        <button className="deposit-date-selector__back" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="deposit-date-selector__header-content">
          <h2 className="deposit-date-selector__title">Дата пополнения</h2>
          <p className="deposit-date-selector__subtitle">
            Когда пополнять цель?
          </p>
        </div>
      </div>
      {renderContent()}
    </div>
  );
};

